
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/users/[userSlug]",
      function () {
        return require("private-next-pages/users/[userSlug]/index.js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/users/[userSlug]"])
      });
    }
  